import { PLAY_PACKAGE } from "@/lib/invite";

export type AppRouteKind =
  | "post"
  | "user"
  | "parallel"
  | "chat"
  | "notifications";

export function buildAppWebPath(kind: AppRouteKind, id?: string): string {
  return kind === "notifications"
    ? "/notifications"
    : `/${kind}/${encodeURIComponent(id ?? "")}`;
}

export function buildPlayStoreUrl(): string {
  return `https://play.google.com/store/apps/details?id=${PLAY_PACKAGE}`;
}

export function buildAndroidIntentUrl(kind: AppRouteKind, id?: string): string {
  const path = buildAppWebPath(kind, id).replace(/^\//, "");
  const fallback = encodeURIComponent(buildPlayStoreUrl());
  return `intent://www.daywia.com/${path}#Intent;scheme=https;package=${PLAY_PACKAGE};S.browser_fallback_url=${fallback};end`;
}
